export function buildSymbolSubscription({
  symbol,
  dataSource,
  brokerage,
  watchlist_name,
}) {
  const normalizedSymbol =
    symbol == null ? '' : String(symbol).trim().toUpperCase();
  if (!normalizedSymbol) return null;
  if (dataSource === 'LIVE' && (!brokerage || brokerage === 'none')) {
    return null;
  }

  return {
    symbol: normalizedSymbol,
    dataSource,
    brokerage,
    watchlist_name,
  };
}

export function sameSymbolSubscription(a, b) {
  if (!a && !b) return true;
  if (!a || !b) return false;

  return (
    a.symbol === b.symbol &&
    a.dataSource === b.dataSource &&
    a.brokerage === b.brokerage &&
    a.watchlist_name === b.watchlist_name
  );
}

export function planSymbolSubscriptionMessages(previousSubscription, nextSubscription) {
  if (sameSymbolSubscription(previousSubscription, nextSubscription)) {
    return [];
  }

  const messages = [];
  if (previousSubscription) {
    messages.push({
      messageType: 'removeSymbol',
      payload: previousSubscription,
    });
  }
  if (nextSubscription) {
    messages.push({
      messageType: 'addSymbol',
      payload: nextSubscription,
    });
  }
  return messages;
}
